import { render } from "./page.deluxe.vue?vue&type=template&id=356436cf"
import script from "./page.deluxe.vue?vue&type=script&lang=js"
export * from "./page.deluxe.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__